/**
 * Love Store Paris — Panneau WhatsApp flottant
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-lsp-floating-wa]');
  if (!root) return;

  var panel = root.querySelector('[data-lsp-wa-gate-modal]');
  var toggleBtn = root.querySelector('[data-lsp-floating-wa-toggle]');
  var confirmBtn = root.querySelector('[data-lsp-wa-gate-confirm]');
  if (!panel || !toggleBtn) return;

  var waUrl = toggleBtn.getAttribute('data-wa-url') || '';

  function isOpen() {
    return root.classList.contains('is-open');
  }

  function openGate() {
    root.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    toggleBtn.setAttribute('aria-expanded', 'true');
  }

  function closeGate() {
    root.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    toggleBtn.setAttribute('aria-expanded', 'false');
  }

  toggleBtn.addEventListener('click', function () {
    if (isOpen()) {
      closeGate();
      return;
    }
    openGate();
  });

  if (confirmBtn) {
    confirmBtn.addEventListener('click', function () {
      if (waUrl) {
        window.open(waUrl, '_blank', 'noopener,noreferrer');
      }
      closeGate();
    });
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && isOpen()) {
      closeGate();
      toggleBtn.focus();
    }
  });

  document.addEventListener('click', function (event) {
    if (!isOpen()) return;
    if (root.contains(event.target)) return;
    closeGate();
  });
})();
